import React from 'react';
import { FormattedDate } from 'react-intl';

import { Text } from '@atlaskit/primitives/compiled/text';

import type { ChangeHistoryVersion } from '../changeHistoryMacroTypes.ts';

export type VersionDateProps = {
	version: ChangeHistoryVersion;
	isCurrent: boolean;
};

export const VersionDate = ({ version, isCurrent }: VersionDateProps): React.JSX.Element => {
	const content = version.when ? (
		<FormattedDate
			value={new Date(version.when)}
			year="numeric"
			month="short"
			day="numeric"
			hour="numeric"
			minute="numeric"
		/>
	) : (
		version.friendlyWhen
	);

	return isCurrent ? <Text as="strong">{content}</Text> : <Text>{content}</Text>;
};
